import classNames from 'classnames';

import {Spinner} from '../../spinner';

import styles from './image-placeholder.module.css';

type Props = {
    className?: string;
    width: number;
    height: number;
};

export const ImagePlaceholder = ({width, height, className}: Props) => {
    const aspectRatio = `${width}/${height}`;

    return (
        <div
            className={classNames(styles.placeholder, className)}
            style={{
                aspectRatio,
            }}
        >
            <Spinner />
        </div>
    );
};
